<template>
  <v-autocomplete
    v-model="selectedFilterBy"
    label="Filtrar por:"
    :items="arrayFilterBy"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    @change="onChanged()"
  >
    <template v-if="multiple" v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedFilterBy.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import rules from "@/utils/rules";

export default {
  name: "SelectFilterBy",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      arrayFilterBy: ["Temperatura", "Data Criação", "Data Proximo Contato"],
      selectedFilterBy: [],
      rules
    };
  },

  methods: {
    selectAll(all = true) {
      if (all) {
        this.selectedFilterBy = this.arrayFilterBy;
      } else {
        this.selectedFilterBy = [];
      }

      this.onChanged();
    },

    onChanged() {
      this.$emit("onChanged", this.selectedFilterBy);
    }
  }
};
</script>
